/**
 * Collection Description — Read More + FAQ Parser
 * Vanilla JS — no jQuery, no external libraries
 *
 * Reads `data-section-id` from the root element to scope
 * all queries to the correct section instance.
 */
(function () {
  'use strict';

  /* ── Initialise a single section instance ──────────────────────────── */
  function initCollectionDescription(root) {
    if (!root) return;

    /* ── Read More / Read Less ─────────────────────────────────────── */
    var fullContent = root.querySelector('.full-content');
    var readMoreBtn = root.querySelector('.read-more-btn');
    var readLessBtn = root.querySelector('.read-less-btn');

    if (fullContent) {
      /* Wrap all children in a single .full-content-inner div —
       * the CSS grid 0fr trick only works with ONE child element. */
      fullContent.classList.remove('is-expanded');

      if (!fullContent.querySelector('.full-content-inner')) {
        var inner = document.createElement('div');
        inner.className = 'full-content-inner';
        while (fullContent.firstChild) {
          inner.appendChild(fullContent.firstChild);
        }
        fullContent.appendChild(inner);
      }
    }

    if (readMoreBtn && fullContent) {
      readMoreBtn.addEventListener('click', function () {
        fullContent.classList.add('is-expanded');
        readMoreBtn.classList.add('is-hidden');
        if (readLessBtn) readLessBtn.classList.add('is-visible');
      });
    }

    if (readLessBtn && fullContent) {
      readLessBtn.addEventListener('click', function () {
        fullContent.classList.remove('is-expanded');
        if (readMoreBtn) readMoreBtn.classList.remove('is-hidden');
        readLessBtn.classList.remove('is-visible');

        /* Scroll back to the start of the section */
        var wrapper = root.closest('.collection-description-wrapper');
        if (wrapper) {
          var top = wrapper.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    }

    /* ── FAQ <details> smooth animation ────────────────────────────── */
    var faqSection = root.querySelector('.faq_content');
    if (faqSection) {
      var allDetails = faqSection.querySelectorAll('details');
      allDetails.forEach(function (detail) {
        wrapDetailsBody(detail);

        var summary = detail.querySelector('summary');
        if (!summary) return;

        summary.addEventListener('click', function (e) {
          e.preventDefault();
          if (detail.hasAttribute('open')) {
            closeDetail(detail);
          } else {
            openDetail(detail);
          }
        });
      });
    }
  }

  /* ── Wrap <details> body for grid animation ────────────────────────── */
  function wrapDetailsBody(detail) {
    if (detail.querySelector('.faq-details-body')) return;

    var summary = detail.querySelector('summary');
    if (!summary) return;

    var bodyWrapper = document.createElement('div');
    bodyWrapper.className = 'faq-details-body';

    var inner = document.createElement('div');
    inner.className = 'faq-answer-inner';

    while (summary.nextSibling) {
      inner.appendChild(summary.nextSibling);
    }

    bodyWrapper.appendChild(inner);
    detail.appendChild(bodyWrapper);
  }

  function openDetail(detail) {
    detail.setAttribute('open', '');
  }

  function closeDetail(detail) {
    var body = detail.querySelector('.faq-details-body');
    if (!body) {
      detail.removeAttribute('open');
      return;
    }

    body.style.gridTemplateRows = '0fr';
    body.addEventListener('transitionend', function handler() {
      body.removeEventListener('transitionend', handler);
      detail.removeAttribute('open');
      body.style.gridTemplateRows = '';
    }, { once: true });

    /* Fallback in case transitionend never fires */
    setTimeout(function () {
      if (detail.hasAttribute('open')) {
        detail.removeAttribute('open');
        body.style.gridTemplateRows = '';
      }
    }, 400);
  }

  /* ── Bootstrap ─────────────────────────────────────────────────────── */
  function bootAll() {
    var sections = document.querySelectorAll('[data-collection-description]');
    sections.forEach(function (section) {
      initCollectionDescription(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  /* Theme Editor live-reload support */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-collection-description]');
    if (section) initCollectionDescription(section);
  });
})();
